const finiteNonzero = value => Number.isFinite(value) && value !== 0;
const positiveInteger = value => Number.isSafeInteger(value) && value > 0;

export const createViewportWheelInputCausalityTracker = () => {
  let phaseActive = false;
  let nextInputOrdinal = 0;
  let nextConsumerFrameOrdinal = 0;
  let phaseBaseInputOrdinal = 0;
  let pending = null;

  const reset = () => {
    phaseActive = false;
    nextInputOrdinal = 0;
    nextConsumerFrameOrdinal = 0;
    phaseBaseInputOrdinal = 0;
    pending = null;
  };

  const observe = ({ bridgeActive, rawDelta, effectiveDelta } = {}) => {
    if (bridgeActive !== true) { reset(); return false; }
    if (!phaseActive) {
      phaseActive = true;
      nextInputOrdinal = 0;
      nextConsumerFrameOrdinal = 0;
      phaseBaseInputOrdinal = nextInputOrdinal;
      pending = null;
    }
    if (!finiteNonzero(rawDelta) || !finiteNonzero(effectiveDelta)
        || Math.sign(rawDelta) !== Math.sign(effectiveDelta)
        || Math.abs(effectiveDelta) > Math.abs(rawDelta)) {
      pending = null;
      return false;
    }
    nextInputOrdinal += 1;
    if (!pending) {
      pending = {
        firstInputOrdinal: nextInputOrdinal,
        lastInputOrdinal: nextInputOrdinal,
        consumedInputCount: 1,
        rawDelta,
        effectiveDelta,
      };
    } else {
      if (Math.sign(pending.rawDelta) !== Math.sign(rawDelta)) { pending = null; return false; }
      pending.lastInputOrdinal = nextInputOrdinal;
      pending.consumedInputCount += 1;
      pending.rawDelta += rawDelta;
      pending.effectiveDelta += effectiveDelta;
    }
    return true;
  };

  const consume = ({ bridgeActive, steps, intentSlice, remainder } = {}) => {
    if (bridgeActive !== true || !phaseActive || !pending
        || !Number.isSafeInteger(steps) || steps === 0
        || !Number.isSafeInteger(intentSlice) || intentSlice < 0
        || !Number.isFinite(remainder) || remainder !== 0
        || Math.sign(steps) !== Math.sign(pending.effectiveDelta)
        || !positiveInteger(pending.firstInputOrdinal)
        || !positiveInteger(pending.lastInputOrdinal)
        || pending.lastInputOrdinal < pending.firstInputOrdinal
        || pending.consumedInputCount !== pending.lastInputOrdinal - pending.firstInputOrdinal + 1) {
      pending = null;
      return null;
    }
    nextConsumerFrameOrdinal += 1;
    const result = Object.freeze({
      phaseBaseInputOrdinal,
      firstInputOrdinal: pending.firstInputOrdinal,
      lastInputOrdinal: pending.lastInputOrdinal,
      consumedInputCount: pending.consumedInputCount,
      rawDelta: pending.rawDelta,
      effectiveDelta: pending.effectiveDelta,
      consumedSteps: steps,
      intentSlice,
      consumerFrameOrdinal: nextConsumerFrameOrdinal,
    });
    pending = null;
    return result;
  };

  return Object.freeze({ observe, consume, reset });
};
